import {
  faBookOpen, faKey, faClipboardList, faMoneyBillTransfer, faWallet, faBuildingColumns,
  faCogs, faTerminal, faBell, faExclamationTriangle, faCode,
} from '@fortawesome/free-solid-svg-icons';
import type { NavTab } from '../../components/apidocs';

/**
 * เมนูฝั่งซ้าย — เพิ่ม tab ใหม่ที่นี่ แล้วผูก component ใน sections/index.ts
 * หมายเหตุ: tab 'endpoints' (Orders API) ถูกซ่อนไว้ตามของเดิม แต่ section ยังอยู่ที่ sections/OrdersSection.tsx
 * ถ้าจะเปิดใช้อีกครั้งให้เอาคอมเมนต์บรรทัดล่างออก (icon: faBullseye)
 */
export const API_DOCS_TABS: NavTab[] = [
  { id: 'overview', icon: faBookOpen, label: 'Overview', category: 'Getting Started' },
  { id: 'authentication', icon: faKey, label: 'Authentication', category: 'Getting Started' },
  // { id: 'endpoints', icon: faBullseye, label: 'Orders API', category: 'API Reference' },
  { id: 'slip-order', icon: faClipboardList, label: 'Slip Order API', category: 'API Reference' },
  { id: 'payout', icon: faMoneyBillTransfer, label: 'Payout API', category: 'API Reference' },
  { id: 'balance', icon: faWallet, label: 'Balance API', category: 'API Reference' },
  { id: 'banks', icon: faBuildingColumns, label: 'Banks API', category: 'API Reference' },
  { id: 'system-status', icon: faCogs, label: 'System Status', category: 'API Reference' },
  { id: 'playground', icon: faTerminal, label: 'API Playground', category: 'Tools' },
  { id: 'webhook-tools', icon: faBell, label: 'Webhook Toolbox', category: 'Tools' },
  { id: 'errors', icon: faExclamationTriangle, label: 'Error Codes', category: 'Tools' },
  { id: 'examples', icon: faCode, label: 'Code Examples', category: 'Resources' },
  { id: 'webhook', icon: faBell, label: 'Webhooks', category: 'Resources' },
];

export const API_DOCS_CATEGORIES = ['Getting Started', 'API Reference', 'Tools', 'Resources'];
